<template>
    <el-row>
        <el-row class="bottom20">
            <el-table ref="table" :data="page.records" highlight-current-row @current-change="handleCurrentRowChange"
                      :row-class-name="getVisitedRowClassName">
                <el-table-column prop="corporation">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">收款单位</span><br>
                        <el-input size="mini" v-model="pageSearch.search.like_corporation" placeholder="收款单位" />
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.corporation}}
                    </template>
                </el-table-column>

                <el-table-column prop="bank">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">开户银行</span><br>
                        <el-input size="mini" v-model="pageSearch.search.like_bank" placeholder="开户银行" />
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.bank}}
                    </template>
                </el-table-column>

                <el-table-column prop="account">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">账号</span><br>
                        <el-input size="mini" v-model="pageSearch.search.like_account" placeholder="账号" />
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.account}}
                    </template>
                </el-table-column>

                <el-table-column prop="contact">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">联系人</span><br>
                        <el-input size="mini" v-model="pageSearch.search.like_contact" placeholder="联系人" />
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.contact}}
                    </template>
                </el-table-column>

                <el-table-column prop="phone">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">电话</span><br>
                        <el-input size="mini" v-model="pageSearch.search.like_phone" placeholder="电话" />
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.phone}}
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </el-row>
</template>

<script>
    import BillingServer from "@/api/billing";

    export default {
        name: "receipt-cfg-page",
        data() {
            return {
                key: 'id',
                currentRow: null,
                currentRowData: null,
                visited: [],
                pageSearch: {
                    current: 1,
                    size: 10,
                    search: {
                        like_corporation: null,
                        like_bank: null,
                        like_account: null,
                        like_contact: null,
                        like_phone: null,
                        eq_status: '1',
                    },
                },
                page: {
                    total: 0,
                    records: []
                },
            };
        },
        computed: {
        },
        watch: {
            'pageSearch.current': {
                deep: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'page': {
                deep: true,
                handler(value) {
                    if (value.total > 0) {
                        let record;
                        let records = value.records;
                        if (this.currentRowData != null && this.currentRowData[this.key] != null) {
                            for (let i = 0, l = records.length; i < l; i++) {
                                if (this.currentRowData[this.key] === records[i][this.key]) {
                                    record = records[i];
                                    break;
                                }
                            }
                        }
                        if (record == null) {
                            record = records[0];
                        }
                        this.select(record);
                    }
                },
            },
            'pageSearch.search': {
                deep: true,
                handler() {
                    this.reQueryByPage();
                }
            }
        },
        methods: {
            handleCurrentRowChange(currentRow) {
                this.currentRow = currentRow;
                this.$emit('selected-change', currentRow);
            },
            handleCurrentChange(current) {
                this.pageSearch.current = current;
            },
            handleSizeChange(size) {
                this.pageSearch.size = size;
            },
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this.pageSearch.current = 1;
                }
            },
            async queryByPage() {
                let pageSearch = this.pageSearch;
                let response = await BillingServer.receiptConfig.page(pageSearch);
                if (response.data.success) {
                    let page = response.data.data;
                    this.page.total = page.total;
                    this.page.records = page.records;
                }
            },
            query() {
                this.queryByPage();
            },
            resetPageSearch() {
                this.pageSearch = {
                    current: 1,
                    size: 10,
                    search: {
                        like_corporation: null,
                        like_bank: null,
                        like_account: null,
                        like_contact: null,
                        like_phone: null,
                    },
                };
            },
            reQuery() {
                this.reQueryByPage();
            },
            select(data) {
                this.$refs.table.setCurrentRow(data);
                this.currentRowData = data;
            },
            /*getSelectedCellClassName({row}) {
                let cellClassName = '';
                if (this.currentRowData && this.currentRowData[this.key] === row[this.key]) {
                    cellClassName += ' currentAccess ';
                }
                return cellClassName;
            },*/
            visit(data) {
                let id = data[this.key];
                if (this.visited.indexOf(id) === -1) {
                    this.visited.push(id);
                }
            },
            getVisitedRowClassName({row}) {
                let rowClassName = '';
                if (this.visited.indexOf(row[this.key]) !== -1) {
                    rowClassName += ' visited';
                }
                return rowClassName;
            },
        },
        mounted() {
            this.query();
        },
    }
</script>

<style scoped>

</style>